//currentUser.js
import request from '@/utils/request';

export function getCurrentUser(data) {
  return request({
    url: 'v1/user_info/current_user',
    method: 'get',
    data: data,
  });
}
